import { render, staticRenderFns } from "./listForm.vue?vue&type=template&id=5a45b1ae&scoped=true&"
import script from "./listForm.vue?vue&type=script&lang=js&"
export * from "./listForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a45b1ae",
  null
  
)

export default component.exports